module.exports = __webpack_public_path__ + "t.no2.e58e0715.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/t.no2.jpg
// module id = dhJq
// module chunks = 0